/**
 * Analytics
 *
 * @namespace APP
 * @name APP.Analytics
 */
APP.Analytics = (/** @lends APP.Analytics */function () {
	'use strict';

	/* eslint no-underscore-dangle: 0 */
	var exports,
		isAnalyticsEnabled = true,
		$body;

	/**
	 * Initialize Google Tag Manager
	 *
	 * @inner
	 * @public
	 * @memberof APP.Analytics
	 * @returns {void}
	 */
	function init() {
		if (isAnalyticsEnabled === true) {
			$body = APP.Performance.getCachedDOM().$body;
			initBindings();
		}

	}

	/**
	 * Initialize event bindings
	 * Search elements with [data-gtm] attribute
	 *
	 * @inner
	 * @memberof APP.Analytics
	 * @returns {void}
	 */
	function initBindings() {
		collectInitialData();

		$('body').on({
			click: function () {
				collectGTMData($(this));
			}
		}, '[data-gtm]');
	}

	function collectInitialData() {
		var dataElement = $body.find('[data-tracker-ref="initial-datalayer"]'),
			params = $.extend({
				pageType: 'selfcare',
				ecommerce: {
					currencyCode: 'HUF'
				},
				originalUrl: window.location.href,
				timestamp: Math.round((new Date()).getTime() / 1000)
			}, dataElement.data('tracker-params'));

		window.dataLayer.push(params);
	}

	function collectGTMData($obj) {
		var type = $obj.attr('data-gtm-type') || false,
			data;

		if (type === 'event') {
			data = {};
			data.category = $obj.attr('data-gtm-category');
			data.action = $obj.attr('data-gtm-action');
			data.label = $obj.attr('data-gtm-label');
			trackEvent(data.category, data.action, data.label, false);
		}

	}

	function popStickyTrack(category) {
		var ssItem,
			ssItemArr;

		if (window.sessionStorage) {


			ssItem = window.sessionStorage.getItem(category);

			try {
				ssItemArr = JSON.parse(ssItem);

				if (!ssItemArr) {
					ssItemArr = [];
				}
			} catch (e) {
				ssItemArr = [];
			}

			ssItemArr.pop();
			window.sessionStorage.setItem(category, JSON.stringify(ssItemArr));

		}
	}

	function setStickyTrack(category, action, label, value) {
		var ssItem,
			ssItemArr,
			lastItem,
			newItem;

		if (window.sessionStorage) {


			ssItem = window.sessionStorage.getItem(category);

			try {
				ssItemArr = JSON.parse(ssItem);

				if (!ssItemArr) {
					ssItemArr = [];
				}
			} catch (e) {
				ssItemArr = [];
			}

			if (ssItemArr.length) {
				lastItem = ssItemArr[ ssItemArr.length - 1 ];
				newItem = {};

				if (action || lastItem.action) {
					newItem.action = action || lastItem.action;
				}

				if (label || lastItem.label) {
					newItem.label = label || lastItem.label;
				}

				if (value || lastItem.value) {
					newItem.value = value || lastItem.value;
				}

				ssItemArr.push(newItem);

			} else {
				ssItemArr = [
					{
						action: action,
						label: label,
						value: value
					}
				];
			}

			window.sessionStorage.setItem(category, JSON.stringify(ssItemArr));

		}
	}

	function sendStickyTrack(category) {
		var ssItem = null,
			ssItemArr = null,
			lastItem;


		if (window.sessionStorage) {


			ssItem = window.sessionStorage.getItem(category);

			try {
				ssItemArr = JSON.parse(ssItem);

				if (!ssItemArr) {
					ssItemArr = [];
				}
			} catch (e) {
				ssItemArr = [];
			}

			if (ssItemArr.length) {
				lastItem = ssItemArr[ ssItemArr.length - 1 ];

				trackEvent(category, lastItem.action, lastItem.label, lastItem.value);
				window.sessionStorage.setItem(category, null);
			}

		}

	}

	/**
	 * Track Event helpers for Google Tag Manager.
	 *
	 * @inner
	 * @memberof APP.Analytics
	 * @param {string} category - Typically the object that was interacted with (e.g. button)
	 * @param {string} action - The type of interaction (e.g. click)
	 * @param {string} label - Useful for categorizing events (e.g. nav buttons)
	 * @param {number} value - Values must be non-negative. Useful to pass counts (e.g. 4 times)
	 * @returns {void}
	 */
	function trackEvent(category, action, label, value) {

		try {
			if(window.dataLayer) {
				if (value) {
					window.dataLayer.push({
						event: 'eventTracker',
						eventCat: category || '',
						eventAct: action || '',
						eventLbl: label || '',
						eventVal: value || ''
					});
				} else {
					window.dataLayer.push({
						event: 'eventTracker',
						eventCat: category || '',
						eventAct: action || '',
						eventLbl: label || ''
					});
				}
			}
		} catch (e) {
			if (window.console) {
				console.warn('Analytics error!');
			}
		}
	}

	function trackEventOnLink(url, category, action, label) {
		try {
			if(window.dataLayer) {
				window.dataLayer.push({
					event: 'eventTracker',
					eventCat: category || '',
					eventAct: action || '',
					eventLbl: label || ''
				});
			}
			document.location = url;
		} catch (e) {
			if (window.console) {
				console.warn('Analytics error!');
			}
		}
	}

	function trackPromoView(promoName, position) {

		var creative = $('[data-campaign-impression="' + promoName + '"]').attr('data-campaign-creative');

		try {
			if(window.dataLayer) {
				window.dataLayer.push({
					event: 'promotionView',
					ecommerce: {
						promoView: {
							promotions: [{
								id: promoName,
								name: 'Selfcare offer',
								creative: creative,
								position: position
							}]
						}
					}
				});
			}
		} catch (e) {
			if (window.console) {
				console.warn('Analytics error!');
			}
		}
	}

	function trackPromoClick($obj, position) {
		$obj.on('click', function() {
			var promoName = $obj.attr('data-campaign-impression'),
				creative = $('[data-campaign-impression="' + promoName + '"]').attr('data-campaign-creative');

			try {
				if (window.dataLayer) {
					window.dataLayer.push({
						event: 'promotionClick',
						ecommerce: {
							promotionClick: {
								promotions: [{
									id: promoName,
									name: 'Selfcare offer',
									creative: creative,
									position: position
								}]
							}
						}
					});
				}
			} catch (e) {
				if (window.console) {
					console.warn('Analytics error!');
				}
			}
		});
	}


	exports = {
		init: init,
		trackEvent: trackEvent,
		trackEventOnLink: trackEventOnLink,
		setStickyTrack: setStickyTrack,
		sendStickyTrack: sendStickyTrack,
		popStickyTrack: popStickyTrack,
		trackPromoView: trackPromoView,
		trackPromoClick: trackPromoClick
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
